import { ReactNode } from "react";
import { createFastContext } from "../createFastContext";

interface IState {
    dataIndex?: number
    hoverId?: string
}

const {
    Provider,
    useStore: useChart,
    setStore: setChart,
    getStore: getChart,
    callEvent: callEventChart
} = createFastContext<IState, {
}>({

});

const ChartProvider = ({ children, ...args }: {
    children: ReactNode,
} & Partial<IState>) => {

    return <Provider props={{ ...args }} >
        {children}
    </Provider>
}


export { callEventChart, ChartProvider, getChart, setChart, useChart };

